import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUserFriends,
  faCommentAlt,
  faPaperPlane,
  faDiamondTurnRight,
} from "@fortawesome/free-solid-svg-icons";
import socket from '../socket';
const { v4: uuidv4 } = require('uuid');

const MessengerContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 13px;
  background: #191919;
  height: calc(100vh - 90px);
  width: 350px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
const MessengerHeader = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 13px;
  justify-content: space-between;
  margin: 10px 0;
  h3 {
    margin: 0;
    font-weight: 400;
    color:#eee;
  }
  .icon {
    cursor: pointer;
    font-size: 20px;
    color:#eee;
  }
`;
const MessengerHeaderTabs = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #000;
  border-radius: 13px;
  .tab {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13px;
    width: 100%;
    color: #eee;
    p {
      margin-left: 10px;
    }
    &.active {
      border-bottom: 2px solid #555;
      color: #eee;
    }
    &:hover {
      cursor: pointer;
      background: #555;
      color: #eee;
    }
  }
`;
const ChatSection = styled.div`
  padding: 20px;
  flex: 1;
  overflow-y: scroll;
  border-radius: 13px;
  .chat-block {
    margin-bottom: 30px;
    border-radius: 13px;
    .sender {
      font-weight: 500;
      font-size: 14px;
      color:#eee;
      small {
        margin-left: 5px;
        font-weight: 300;
      }
    }
    .msg {
      margin: 0;
      padding-top: 5px;
      color: #eee;
      font-size: 14px;
    }
  }
`;

const MessageList = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 15px;
  color: #454552;
`;

const Message = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  margin-top: 15px;
  margin-left: 15px;
  text-align: left;

  > strong {
    margin-left: 3px;
  }

  > p {
    max-width: 65%;
    width: auto;
    padding: 9px;
    margin-top: 3px;
    border: 1px solid rgb(78, 161, 211, 0.3);
    border-radius: 15px;
    box-shadow: 0px 0px 3px #4ea1d3;
    font-size: 14px;
  }
`;

const UserMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  font-size: 16px;
  margin-top: 15px;
  text-align: right;

  > strong {
    margin-right: 35px;
  }

  > p {
    max-width: 65%;
    width: auto;
    padding: 9px;
    margin-top: 3px;
    margin-right: 30px;
    border: 1px solid rgb(78, 161, 211, 0.3);
    border-radius: 15px;
    background-color: #4ea1d3;
    color: white;
    font-size: 14px;
    text-align: left;
  }
`;

const SendMessageSection = styled.div`
  padding: 20px;
  border-top: 1px solid #191919;
  border-bottom: 1px solid #191919;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #eee;
  input {
    padding: 5px;
    border: none;
    border-radius: 22px; 
    line-height: 1.62rem;
    width: 80%;
    outline: none;
    border-bottom: 1px solid #191919;
    .icon {
      cursor: pointer;
      &:hover {
        color: #eee;
      }
    }
  }
`;
const Messanger = ({roomId}) => {
  const currentUser = sessionStorage.getItem('user');
  const [msg, setMsg] = useState([]);
  const messagesEndRef = useRef(null);
  const inputRef = useRef();
  
  useEffect(() => {
    socket.on('FE-receive-message', ({ msg, sender }) => {
      setMsg((msgs) => [...msgs, { sender, msg }]);
      console.log(sender)
    });
  }, []);

  // Scroll to Bottom of Message List
  useEffect(() => {scrollToBottom()}, [msg])

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: 'smooth'});
  }

  const sendMessage = (e) => {
    if (e.key === 'Enter') {
      const msg = e.target.value;

      if (msg) {
        console.log(msg)
        
        socket.emit('BE-send-message', { roomId, msg, sender: currentUser });
        inputRef.current.value = '';
      }
    }
  };
  return (
    <MessengerContainer className="messenger-container">
      <MessengerHeader className="messenger-header">
        <h3>Meeting details</h3>
        <FontAwesomeIcon className="icon" icon={faTimes} />
      </MessengerHeader>

      <MessengerHeaderTabs className="messenger-header-tabs">
        <div className="tab">
          <FontAwesomeIcon className="icon" icon={faUserFriends} />
          <p>People (1)</p>
        </div>
        <div className="tab active">
          <FontAwesomeIcon className="icon" icon={faCommentAlt} />
          <p>Chat</p>
        </div>
      </MessengerHeaderTabs>

      <ChatSection className="chat-section">
      <MessageList>
          {msg &&
            msg.map(({ sender, msg }, idx) => {
              console.log(msg)
              if (sender !== currentUser) {
                return (
                  <Message key={idx}>
                    <strong>{sender}</strong>
                    <p>{msg}</p>
                  </Message>
                );
              } else {
                return (
                  <UserMessage key={idx}>
                    <strong>{sender}</strong>
                    <p>{msg}</p>
                  </UserMessage>
                );
              }
            })}
            <div style={{float:'left', clear: 'both'}} ref={messagesEndRef} />
        </MessageList>
      </ChatSection>

      <SendMessageSection className="send-msg-action">
        <input ref={inputRef} onKeyUp={sendMessage} placeholder="Send a message to everyone" />
        <FontAwesomeIcon className="icon" icon={faPaperPlane} />
      </SendMessageSection>
    </MessengerContainer>
  );
};

export default Messanger;
